var React = require('react');

function Arflag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#25346d","d":"M0 0h774.54v542.18H0z","key":0}),React.createElement("path",{"fill":"#75acde","d":"M0 0h774.54v542.18H0z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 180.73h774.54v180.73H0z","key":2}),React.createElement("circle",{"cx":"387.27","cy":"271.09","r":"77.13","fill":"#fedf0d","key":3})]);
}

Arflag.defaultProps = {"overflow":"visible","viewBox":"0 0 774.54 542.18"};

module.exports = Arflag;

Arflag.default = Arflag;
